export default __webpack_public_path__ + "static/media/cell-culture-screening-solution.dc27d7a4.png";